import { render, staticRenderFns } from "./SettingsSocial.vue?vue&type=template&id=6a1d7cfb&scoped=true"
import script from "./SettingsSocial.vue?vue&type=script&lang=ts&setup=true"
export * from "./SettingsSocial.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./SettingsSocial.vue?vue&type=style&index=0&id=6a1d7cfb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1d7cfb",
  null
  
)

export default component.exports